module.exports = __webpack_public_path__ + "static/KontorBeth-e4ec735890256f466802c56aa1454659.png";